import { useState } from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { TrustStats } from '../components/landing/TrustStats';
import { ProblemSection } from '../components/landing/ProblemSection';
import { ArchitectureFlow } from '../components/landing/ArchitectureFlow';
import { LiveDemoSandbox } from '../components/landing/LiveDemoSandbox';
import { IntegrationTimeline } from '../components/landing/IntegrationTimeline';
import { Features } from '../components/landing/Features';
import { DeveloperPlayground } from '../components/landing/DeveloperPlayground';
import { SecuritySection } from '../components/landing/SecuritySection';
import { Pricing } from '../components/landing/Pricing';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
import { InterceptModal } from '../components/landing/InterceptModal';

export function LandingPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalActionName, setModalActionName] = useState<string | undefined>(undefined);

  const handleWriteAction = (actionName: string) => {
    setModalActionName(actionName);
    setModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-surface text-ink antialiased selection:bg-blue-500/20">
      <Navbar />
      <main>
        <Hero />
        <TrustStats />
        <ProblemSection />
        <ArchitectureFlow />
        <LiveDemoSandbox onWriteAction={handleWriteAction} />
        <IntegrationTimeline />
        <Features />
        <DeveloperPlayground />
        <SecuritySection />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />

      {/* Intercept Modal for interactive sandbox write actions */}
      <InterceptModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        actionName={modalActionName}
      />
    </div>
  );
}

export default LandingPage;
